import {
  ChangeDetectionStrategy,
  Component,
  inject,
  InjectionToken,
  input,
  Type,
  viewChild,
} from '@angular/core';

import { injectTranslate } from '@recruitee/i18n';

import { IconComponent } from '../../../../common/icon/icon.component';
import { IconName } from '../../../../icons-container/icons.type';
import { InputComponent } from '../../../input/input.component';
import { NgTemplateLifecycleDirective } from '../../utils/ng-template-lifecycle.directive';
import { Select2TriggerDirective } from './trigger.directive';

export const DEFAULT_TRIGGER_COMPONENT = new InjectionToken<Type<Select2TriggerComponent>>(
  'default trigger',
);

@Component({
  selector: 'rt-select-trigger',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [Select2TriggerDirective, InputComponent, NgTemplateLifecycleDirective, IconComponent],
  template: `
    <ng-template rtSelectTrigger #triggerDir="triggerDir" let-selectCtrl let-inOverlay="inOverlay">
      <rt-input
        #inputCmp
        ngTemplateLifecycle
        (ngInit)="triggerDir.setFocusable(inputCmp.input)"
        [readOnly]="true"
        [placeholder]="placeholder()"
        [hasDropdownIndicator]="true"
        [class.dropdownOpened]="selectCtrl.isOpen()"
        [value]="selectCtrl.itemSelector.selected()?.label ?? null"
        (click)="selectCtrl.toggle(true)"
        variant="rounded"
      >
        @if (iconName()) {
          <rt-icon prefix [name]="iconName()!"></rt-icon>
        }
      </rt-input>
    </ng-template>
  `,
  styleUrls: ['./trigger-default.component.less'],
  providers: [
    {
      provide: Select2TriggerDirective,
      useFactory: () => inject(Select2TriggerComponent).directive(),
    },
  ],
})
export class Select2TriggerComponent {
  public directive = viewChild.required(Select2TriggerDirective);

  public placeholder = input<string>(injectTranslate()('rtu.ui.select.placeholder'));
  public iconName = input<IconName | null>(null);
}
